module.exports = __webpack_public_path__ + "static/media/andreaBook.9a29281c.jpg";